import request from '@/utils/request'

// 订单号查询订单重定向
export function login() {
    return request({
        url: '/api/category',
        method: 'get'
    })
}


// 投放房源
export function putIn(data) {
    return request({
        url: '/index/house.putin/add',
        method: 'post',
        data
    })
}

// 委托找房
export function contracts(data) {
    return request({
        url: '/index/house.contracts/add',
        method: 'post',
        data
    })
}

// 地区找房
export function area() {
    return request({
        url: '/index/house.area/list',
        method: 'get',
    })
}

// 地区找房
export function district() {
    return request({
        url: '/index/house.district/list',
        method: 'get',
    })
}

// 地区找房
export function districtAll() {
    return request({
        url: '/index/house.district/all',
        method: 'get',
    })
}

// 地区找房
export function homeBuildings() {
    return request({
        url: '/index/house.building/list',
        method: 'get',
    })
}

// 搜索
export function buildingSearch(data) {
    return request({
        url: '/index/house.building/search',
        method: 'get',
        params: data
    })
}
// 搜索
export function otherList(data) {
    return request({
        url: '/index/house.building/otherList',
        method: 'get',
        params: data
    })
}

export function buildingDetail(id) {
    return request({
        url: '/index/house.building/detail&id=' + id,
        method: 'get',
    })
}

export function getHouseDetail(id) {
    return request({
        url: '/index/house/detail&id=' + id,
        method: 'get',
    })
}

export function houseList(data) {
    return request({
        url: '/index/house/list',
        method: 'post',
        data
    })
}

// 地区找房
export function decoration_type() {
    return request({
        url: '/index/house.decoration_type/list',
        method: 'get',
    })
}

// 获取轮播图
export function storeData() {
    return request({
        url: '/index/store/data',
        method: 'get',
    })
}
